(() => {
  const chooseLinkedVariant = () => {
    const variantId = new URL(location.href).searchParams.get('variant');
    if (!variantId || !/^\d+$/.test(variantId)) return;
    const picker = document.querySelector('#product_select');
    if (!picker || picker.querySelector('.active')) return;
    const option = Array.from(picker.querySelectorAll('[variant-option="available"]:not([data-show-fake])')).find(item => item.dataset.pmVariantId === variantId);
    if (option) option.click();
  };
  if (document.readyState === 'complete') chooseLinkedVariant();
  else window.addEventListener('load', chooseLinkedVariant, { once: true });
})();